import React from "react";
import DisplayError from "../../common/DisplayError";
import "./DropdownField.css";
import type { CustomRegisterFieldProps, StandardFieldProps } from "../types";
import { useFormContext } from "react-hook-form";

const DropdownField: React.FC<StandardFieldProps> = (props) => {
  const { field, error } = props;
  const form = useFormContext();
  const { setValue, watch } = form;
  const currentValue = watch(field.name) || "";

  const handleChange = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    ev.persist();
    setValue(field.name, ev.target.value);
  };

  return (
    <div className="main-container mb-2">
      <label htmlFor={field.name} className="form-label">
        {field.label}:
      </label>
      <select
        id={field.name}
        name={field.name}
        className={`form-select ${error ? "is-invalid" : ""}`}
        onChange={handleChange}
        value={currentValue}
        disabled={field.disabled}
      >
        {field.placeholder && (
          <option value="" disabled>
            {field.placeholder}
          </option>
        )}
        {field.options?.map((option) => (
          <option key={option.key || option.value} value={option.key}>
            {option.value}
          </option>
        ))}
      </select>
      <DisplayError
        hideEmptyError={false}
        errorCondition={error}
        errorMessage={error && error.message}
      />
    </div>
  );
};

export default DropdownField;
